import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type InitialState = {
  searchTerm: string;
};

const initialState: InitialState = {
  searchTerm: '',
};

export const cooperativeCommonCasesSlice = createSlice({
  name: 'cooperativeCommonCases',
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    reset: (state) => {
      Object.assign(state, initialState);
    },
  },
});
